import { render, staticRenderFns } from "./neighbour-item.vue?vue&type=template&id=747077d6&scoped=true"
import script from "./neighbour-item.vue?vue&type=script&lang=js"
export * from "./neighbour-item.vue?vue&type=script&lang=js"
import style0 from "./neighbour-item.vue?vue&type=style&index=0&id=747077d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747077d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747077d6')) {
      api.createRecord('747077d6', component.options)
    } else {
      api.reload('747077d6', component.options)
    }
    module.hot.accept("./neighbour-item.vue?vue&type=template&id=747077d6&scoped=true", function () {
      api.rerender('747077d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/neighbours-view-renderer/neighbour-item.vue"
export default component.exports